// extracted by mini-css-extract-plugin
module.exports = {"video-wrapper":"video-wrapper__OHTGv","video":"video__35iRW","fit-width":"fit-width__3P_5O"};